import React from 'react'
import { stringify, parse } from 'query-string'
import { history } from 'src/services/history'
import debounce from 'lodash/debounce'
import ObjectObserver from 'src/util/ObjectObserver'

/**
 * An object observer synchronized with the url search
 */
const QueryParamsObserver = new ObjectObserver(parseSearch())

/**
 * Get the query params from the url
 */
function parseSearch() {
  return parse(history.location.search, { parseBooleans: true, arrayFormat: 'comma' })
}

/**
 * Get the query params from the url
 */
function stringifyObject() {
  return stringify(QueryParamsObserver.get(), { arrayFormat: 'comma' })
}

/**
 * Check if url query params and synchronized params are different
 */
function isSearchDifferent() {
  return stringifyObject() !== history.location.search.slice(1)
}

/**
 * Replace url query params, debounced.
 */
const replaceSearch = debounce(() => isSearchDifferent() && history.replace({ search: stringifyObject() }), 500)

/**
 * Replace synchronized object
 */
const replaceObject = () => isSearchDifferent() && QueryParamsObserver.set(parseSearch())

export default QueryParamsObserver

/**
 * Hook initializing subscriptions
 */
export function useQueryParamsSubscriptions() {
  // update local state when search changes
  React.useEffect(() => history.listen(replaceObject), [])
  // update search when local state changes
  QueryParamsObserver.useSubscribe(replaceSearch)
}
